import {
  CommonInputWidgetConfigSchema,
  DefaultAssignableExpressionSchema,
  RichTextAdvancedSchema,
  toAdvancedRichText,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { IProvinceWidget, WidgetProvinceType } from './IProvinceWidget';

export const ProvinceWidgetConfigSchema: yup.ObjectSchema<IProvinceWidget> =
  CommonInputWidgetConfigSchema.shape({
    label: yup.mixed().strip(),
    type: yup.string().exact(WidgetProvinceType).required(),
    placeholder: yup.mixed().strip(),
    provinceLabel: RichTextAdvancedSchema.nonNullable().default(() =>
      toAdvancedRichText('Provincia'),
    ),
    townLabel: RichTextAdvancedSchema.nonNullable().default(() =>
      toAdvancedRichText('Comune'),
    ),
    provincePlaceholder: yup.string().notRequired().default('Provincia'),
    townPlaceholder: yup.string().notRequired().default('Comune'),

    provinceHelpText: RichTextAdvancedSchema.optional()
      .nonNullable()
      .default(() => toAdvancedRichText('')),
    townHelpText: RichTextAdvancedSchema.optional()
      .nonNullable()
      .default(() => toAdvancedRichText('')),

    defaultProvince: DefaultAssignableExpressionSchema.optional(),
    defaultTown: DefaultAssignableExpressionSchema.optional(),
  })
    .required()
    .noUnknown();
